import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const InstructorProfile = lazyRouteComponent(() => import('@/_instructor/profile'));

export const Route = createFileRoute('/_instructor/profile')({
  component: () => renderInstructorPage(InstructorProfile),
});
